import { AssciCode } from '@/common/constant'

/**
 * @author PVThang
 * @description format chuỗi
 * @param {any} value Giá trị được fomat
 * @param {Number} targetLength Độ dài chuỗi sau khi format
 * @param {String} padString chuỗi được thay thế
 */
const formatText = (value, targetLength, padString = ' ') => {
  return (value || '').toString().padStart(targetLength, padString)
}

/**
 * @author PVThang
 * @param {Number} sortOrder số thứ tự của chữ cái trong bảng chữ cái tiếng anh
 * @returns chữ cái tiếng anh theo sortOrder
 */
const getLetterBySortOrder = (sortOrder) => {
  // -1 vì sortOder bắt đầu từ 1
  // AssciCode[0] - assci code của chữ cái đầu tiên
  // AssciCode[1] - assci code của chữ cái cuối cùng
  let letterAssciCode = AssciCode.Upper[0] + sortOrder - 1

  // Chặn, chỉ lấy trong khoảng chữ in hoa
  if (letterAssciCode < AssciCode.Upper[0]) {
    letterAssciCode = AssciCode.Upper[0]
  }
  if (letterAssciCode > AssciCode.Upper[1]) {
    letterAssciCode = AssciCode.Upper[1]
  }

  return String.fromCharCode(letterAssciCode)
}

export { formatText }
export { getLetterBySortOrder }
